var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.auditStatistics)?_c('number-card',{attrs:{"danger":"","bold":"","amount":_vm.auditsWithAnomalies,"title":_vm.$it('dashboard.card.audits-with-anomalies-this-month.title', 'Audits with anomalies this month')}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }